var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quote-preview',{attrs:{"quote":_vm.quote,"imageUrl":_vm.quote.logo,"quotedDateFormatted":this.formatDate(_vm.quote.quoted_date),"pdf":"pdf"}})
}
var staticRenderFns = []

export { render, staticRenderFns }